import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Summary from './summary';
import Bio from './bio';
import MissingWireImageTip from './missing-wire-image-tip';
import Menu from './menu';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font: ${props => props.theme.fontWeightBold} 19px/25px ${props => props.theme.fontFamilyBody};
  ${props => !(props.theme.isMobile) && `
    flex-grow: 10;
    flex-shrink: 10;
  `}
`;

const VFlex = styled.div`
  flex-grow: 10;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export default function Description({
  title, slug, primaryImageUrl, contributor, id,
}) {
  return (
    <Container>
      <VFlex>
        <Summary isPale={!!primaryImageUrl} title={title} />
        {primaryImageUrl ? <Bio {...contributor} /> : <MissingWireImageTip />}
      </VFlex>
      <Menu slug={slug} id={id} />
    </Container>
  );
}

Description.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  primaryImageUrl: PropTypes.string,
  contributor: PropTypes.shape({
    name: PropTypes.string.isRequired,
    organization: PropTypes.string,
  }).isRequired,
};

Description.defaultProps = {
  primaryImageUrl: null,
};
